<template>
  <el-dialog  :title="dialogName" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px" top="140px" :show-close="false">
    <div style="height: 400px;">
      <div class="remind-content" v-if="expiredStatus == 1">您的权益已过期，如需正常请点击下面续费按钮续费！</div>
      <div class="remind-content" v-if="expiredStatus == 2">您的权益快到期啦，未避免正常使用请及时续费！</div>
      <div class="remind-date">权益到期日期：{{memberValidDate}}</div>
    </div>
    <div slot="footer" class="dialog-footer">
      <xr-button type="primary" @click="buy()">权益续费</xr-button>
      <xr-button type="default" v-if="expiredStatus != 1" @click="dialogVisible = false">关闭</xr-button>
      <xr-button type="default" v-if="expiredStatus == 1" @click="loginOut">退出登录</xr-button>
    </div>

    <combo-buy ref="comboBuy" v-if="isComboBuyShow"></combo-buy>

  </el-dialog>
</template>

<script>

  import ComboBuy from '../../../../components/header/Combo-Buy'

export default {
  name: 'inStockAddOrEdit',
  data() {
    return {
      dialogName: '权益到期提醒',
      dialogVisible: true,
      type: '',
      category_list:[],                  //分类列表
      service_list:[],                   //服务列表
      purchaseOrgId_list: [],            //采购商
      goodsStats_list:[],                //属性列表
      goodsStats: [],                    //选中的属性
      serviceIds: [],                    //选中的服务
      isComboBuyShow: false,
      mainImgList: [],
    }
  },
  components: {
    // Ueditor,
    ComboBuy
  },
  computed: {
    expiredStatus() {
      return this.$store.getters.expiredStatus; //获取机构类型
    },
    memberValidDate() {
      return this.$store.getters.memberValidDate; //获取机构类型
    }
  },
  methods: {
    //初始化页面
    init(type, id) {
      this.dialogVisible = true;
    },
    // 关闭弹窗
    closeDialog() {
      this.$emit('close')  // 触发关闭事件
    },
    buy(){
      this.isComboBuyShow = true;
      this.$nextTick(()=>{
        this.$refs.comboBuy.init() //初始化页面
      })
    },
    //退出登录
    loginOut(){
      this.$store.dispatch('user/logout')
        .then(() => {
          location.reload()
        })
        .catch(() => {
          location.reload()
        })
    }
  }
}
</script>

<style scoped>

/* 给提示文字加个类名，使其在样式上与其他内容区分开来 */
.hint-text {
  font-size: 14px;
  color: #a9a9ab;
  /*margin-bottom: 15px;*/
  margin-top: 5px;
}

  .remind-content{
    font-family: "华文行楷", "STXingkai", "Xingkai SC", "Kaiti SC", cursive;
    font-size: 40px;
    text-align: center;
    margin-top: 200px;
    font-weight: 600;
  }

  .remind-date{
    text-align: center;
    margin-top: 100px;
    color: red;
    font-size: 25px;
    font-weight: 600;
  }

</style>



// WEBPACK FOOTER //
// src/views/base/remind/item/vip-remind.vue